import type { BlogPost } from "./blog";

export const BLOG_BIRTHDAY_PART2: BlogPost[] = [
  {
    "slug": "den-rozhdeniya-devushki-restoran-spb",
    "title": "День рождения девушки в ресторане Петербурга: идеи и вдохновение",
    "metaTitle": "День рождения девушки в ресторане СПб | Паруса на крыше",
    "metaDescription": "Где отметить день рождения девушки в Санкт-Петербурге: романтика, вид, живая музыка. Скидка 20% именинницам. Ул. Марата 5.",
    "keywords": "день рождения девушки ресторан спб, праздник девушке петербург, день рождения подруги ресторан",
    "date": "2026-06-19",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "День рождения девушки — это не просто «отметить». Это создать атмосферу, которая останется в памяти. Красивое место, хорошее вино, живая музыка, вид на Петербург — и она это запомнит.",
    "sections": [
      {
        "heading": "Что важно для дня рождения девушки",
        "body": "Девушки ценят в праздновании: красивую атмосферу, живую музыку, удобный стол, красивые блюда и хорошее вино. «Паруса на крыше» дают всё это: панорамный вид с 6-го этажа, авторские блюда, живая музыка в четверг–воскресенье. Десерт от шеф-кондитера в подарок именинницам.",
        "list": [
          "Красивый вид — главная атмосфера",
          "Живая музыка — без доплаты",
          "Десерт именинницы — в подарок",
          "Скидка 20% на счёт именинницы"
        ]
      },
      {
        "heading": "Форматы для праздника девушки",
        "body": "Романтический ужин вдвоём — если хочется только вас двоих. Девичник — 6–12 подруг, столик или небольшой зал. Большой праздник — 20–50 человек, смешанная компания. В «Парусах» все форматы возможны. Менеджер поможет подобрать стол или зал под нужный размер.",
        "highlight": "Стол у панорамного окна для двоих на день рождения девушки — это романтика, которую не нужно объяснять. Вид говорит за всё."
      },
      {
        "heading": "Как сделать вечер особенным",
        "body": "Маленькие детали: попросить принести тот самый десерт с надписью, заблаговременно договориться о цветах (можно заказать через флориста самостоятельно и принести), выбрать стол заранее с лучшим видом. В «Парусах» персонал умеет создавать «тот самый момент»: выход торта с живой музыкой — это то, что она сфотографирует и опубликует.",
        "list": [
          "Цветы — принести заранее или через флориста",
          "Лучший стол — просите при бронировании",
          "Торт с именем и датой — под заказ",
          "Выход торта под живую музыку — всегда работает"
        ]
      }
    ],
    "cta": { "text": "Забронировать день рождения девушки", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "krasivyy-prazdnik-devushke-peterburg",
    "title": "Красивый день рождения для девушки в Петербурге: топ идей",
    "metaTitle": "Красивый день рождения для девушки — Петербург | Паруса",
    "metaDescription": "Топ идей для красивого дня рождения девушки в Санкт-Петербурге: ресторан с видом, белые ночи, живая музыка, десерт в подарок.",
    "keywords": "красивый день рождения девушке петербург, стильный праздник девушке спб, оригинальный день рождения",
    "date": "2026-06-19",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_clouds.webp",
    "lead": "Хочется сделать ей праздник, который она вспомнит через годы. Не стандартный ресторан и торт — а что-то с характером. Петербург даёт для этого идеальные условия.",
    "sections": [
      {
        "heading": "Идеи для красивого праздника",
        "body": "Ужин с видом на белые ночи. Терраса в июне — она точно не забудет. Живая музыка, когда приносят торт. Бокал шампанского при входе. Именная карточка на столе. Флористический акцент — несколько живых цветов. Это не дорого и не сложно — но каждая деталь добавляет ощущение особенности.",
        "list": [
          "Терраса в белые ночи — июнь-июль",
          "Живая музыка к торту",
          "Шампанское при входе",
          "Именная карточка на столе"
        ]
      },
      {
        "heading": "Что ценится больше всего",
        "body": "Опыт показывает: больше всего запоминается не размер торта или цена блюд — а момент. Тот самый момент, когда огни города за окном, звучит любимая мелодия и все вместе. В «Парусах» такие моменты случаются регулярно. Именно за этим сюда возвращаются. Рейтинг 5,0, 2 606+ отзывов.",
        "highlight": "Самый красивый праздник девушки — не самый дорогой. Это тот, где был момент. В «Парусах» мы умеем его создать."
      },
      {
        "heading": "Бронирование",
        "body": "Позвоните за 3–5 дней: +7 (812) 991-10-90. Расскажите, что хотите «особенный вечер для неё». Менеджер поможет выбрать стол и детали. Скидка 20% именинницам.",
        "list": [
          "Бронируйте за 3–5 дней",
          "Скажите: «особенный вечер»",
          "Скидка 20% именинницам",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать красивый праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-podrugi-restoran-spb",
    "title": "День рождения подруги в ресторане Петербурга: как удивить",
    "metaTitle": "День рождения подруги в ресторане СПб | Паруса на крыше",
    "metaDescription": "Как организовать незабываемый день рождения подруги в Санкт-Петербурге: ресторан с видом, скидка 20%, живая музыка. Идеи для сюрприза.",
    "keywords": "день рождения подруги ресторан спб, сюрприз подруге петербург, праздник подруге идеи",
    "date": "2026-06-19",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Организовать день рождения подруги — значит показать, что вы знаете её вкусы. Красивое место, правильная атмосфера, её любимые люди рядом. Разбираем, как это сделать в Петербурге.",
    "sections": [
      {
        "heading": "Сюрприз или нет",
        "body": "Если организуете сюрприз — скажите об этом менеджеру при бронировании. Команда «Парусов» умеет: встретить именинницу с живой музыкой, принести торт неожиданно, создать момент. Если планируете открыто — лучше: она сможет выбрать стол и заранее знает, чего ждать. Оба варианта хороши.",
        "list": [
          "Сюрприз: скажите менеджеру при бронировании",
          "Открытый праздник: именинница участвует в выборе",
          "Торт с именем и сюрпризом — под заказ",
          "Скидка 20% имениннице"
        ]
      },
      {
        "heading": "Девичник в ресторане",
        "body": "Если день рождения подруги — это повод собрать девичник: 6–12 подруг, хорошее вино, живая музыка, авторская кухня. В «Парусах» для этого подходит стол-«подкова» у окна или небольшой зал. Панорамный вид на Петербург становится фоном для бесчисленных фото.",
        "highlight": "Девичник в «Парусах» — это фото с видом на Казанский собор, которые потом ставят на обложку. Это работает само."
      },
      {
        "heading": "Что заказать",
        "body": "Для девичника: игристое на старт, лёгкие закуски, основное на выбор каждой, торт на всех. Средний чек ~1 300 ₽/чел. Скидка 20% на счёт именинницы. +7 (812) 991-10-90.",
        "list": [
          "Игристое — на старт",
          "Лёгкие закуски — для общего стола",
          "Скидка 20% имениннице",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать день рождения подруги", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-muzhchiny-restoran-spb",
    "title": "День рождения мужчины в ресторане Петербурга: по-мужски",
    "metaTitle": "День рождения мужчины в ресторане СПб | Паруса на крыше",
    "metaDescription": "Где отметить день рождения мужчины в Санкт-Петербурге: хороший стейк, вино, живая музыка. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "день рождения мужчины ресторан спб, праздник мужчины петербург, день рождения друга",
    "date": "2026-06-20",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "День рождения мужчины — это не розовые шарики и пышный торт. Это хорошее мясо, правильное вино, вид, который вызывает уважение, и компания, в которой комфортно. «Паруса на крыше» — то самое место.",
    "sections": [
      {
        "heading": "Что важно мужчинам на дне рождения",
        "body": "Опыт показывает: мужчины ценят в праздновании хорошую еду, правильную атмосферу без лишней суеты и качественный сервис. Не нужны конкурсы и «весёлый ведущий» — нужен хороший стейк, бутылка рибейра дель дуэро и вид на Петербург с 6-го этажа. «Паруса» это дают.",
        "list": [
          "Хорошее мясо: стейки, утка, ягнёнок",
          "Карта вин с красными вариантами",
          "Панорамный вид — без объяснений",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Форматы мужского дня рождения",
        "body": "Мужчина + лучшие друзья: 5–12 человек, стол у окна, стейки и вино. Смешанная компания с женщинами: 15–30 гостей, небольшой зал. Корпоративный день рождения: коллеги плюс друзья, до 50 человек. Банкет на юбилей: с программой и ведущим. В «Парусах» все форматы возможны.",
        "highlight": "Мужской день рождения в «Парусах» — это вид на Петербург, который заставляет замолчать и просто смотреть. Хорошее начало вечера."
      },
      {
        "heading": "Что заказать на мужской день рождения",
        "body": "Стейк рибай или томагавк — главное блюдо. Мясная нарезка на старт. Красное вино из Испании или Аргентины. Торт — если мужчина любит сладкое, или сырная тарелка как альтернатива. Виски или коньяк в конце. Официант поможет составить правильный вечер.",
        "list": [
          "Стейк — главное блюдо",
          "Красное вино к мясу",
          "Мясная нарезка на старт",
          "Сырная тарелка или торт — на финал"
        ]
      }
    ],
    "cta": { "text": "Забронировать мужской день рождения", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "kuda-svodit-muzha-den-rozhdeniya-spb",
    "title": "Куда сводить мужа на день рождения в Петербурге: идеи",
    "metaTitle": "Куда сводить мужа на день рождения в Петербурге | Паруса",
    "metaDescription": "Лучшие идеи, куда сводить мужа на день рождения в Санкт-Петербурге. Ресторан с видом и живой музыкой. Скидка 20% именинникам.",
    "keywords": "куда сводить мужа день рождения петербург, праздник для мужа спб, день рождения мужа идеи",
    "date": "2026-06-20",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Муж говорит «не надо ничего особенного» — и это значит, что надо сделать что-то особенное. Разбираем, куда повести его в Петербурге, чтобы он потом сказал «это было круто».",
    "sections": [
      {
        "heading": "Что оценит муж",
        "body": "Мужчины не любят пустого пафоса. Они ценят: хорошую еду, качественный алкоголь, красивое место без объяснений. Когда вы приводите его в «Паруса на крыше» и он видит Петербург с 6-го этажа — вы уже выиграли. Это место не нужно объяснять. Дальше — стейк, вино и правильная компания.",
        "list": [
          "Стол с лучшим видом — он оценит без слов",
          "Хорошее вино: красное к мясу",
          "Стейк или рибай — его блюдо",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Сюрприз или вместе",
        "body": "Если хотите сюрприз: забронируйте стол, придумайте повод «просто пойдём поужинаем» — и привезите. Когда он увидит вид с 6-го этажа и стол с декором — эффект будет. Если он знает: пусть сам выберет что заказать. Это тоже правильно. В «Парусах» менеджер помогает с обоими сценариями.",
        "highlight": "Сюрприз в «Парусах» — это когда лифт открывается на 6-м этаже и перед ним Петербург во всей красе. Это «вау», которое работает всегда."
      },
      {
        "heading": "Практические детали",
        "body": "Позвоните заранее: +7 (812) 991-10-90. Скажите «день рождения мужа, стол на [количество]». Попросите лучший стол с видом. Уточните о скидке именинникам. Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж.",
        "list": [
          "+7 (812) 991-10-90",
          "Попросите лучший стол с видом",
          "Скидка 20% мужу-именинникам",
          "Olympic Plaza, 6-й этаж"
        ]
      }
    ],
    "cta": { "text": "Забронировать для мужа", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "yubiley-40-let-restoran-spb",
    "title": "Юбилей 40 лет в Петербурге: как отпраздновать по высшему разряду",
    "metaTitle": "Юбилей 40 лет в Петербурге — ресторан | Паруса на крыше",
    "metaDescription": "Юбилей 40 лет в Санкт-Петербурге: ресторан с панорамным видом, банкет, живая музыка. Скидка 20% именинникам. Банкетное меню от 2500 ₽.",
    "keywords": "юбилей 40 лет ресторан петербург, сорокалетие банкет спб, где отметить 40 лет",
    "date": "2026-06-20",
    "category": "День рождения в Петербурге",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Сорок лет — рубеж. Первый настоящий юбилей, который хочется отметить так, чтобы говорили об этом вечере. Петербург умеет создавать такие вечера, а «Паруса» помогают их провести.",
    "sections": [
      {
        "heading": "40 лет: особый статус праздника",
        "body": "Сорок лет в русской культуре — особая дата. Первый большой юбилей. Гостей обычно много: от родственников до коллег. Нужно место, которое соответствует масштабу. «Паруса на крыше» — ресторан с вместимостью до 300 гостей, панорамным видом и командой, которая умеет организовывать юбилеи.",
        "list": [
          "До 300 гостей",
          "Несколько залов под разный размер",
          "Банкетный менеджер ведёт вечер",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Детали незабываемого юбилея",
        "body": "Что делает юбилей незабываемым: именной торт с 40 свечами (или оригинальная концепция), слайд-шоу из фотографий (трогает любых гостей), живая музыка в нужный момент, правильный вынос торта. В «Парусах» всё это возможно. Банкетный менеджер поможет скоординировать каждый элемент.",
        "highlight": "Юбилей 40 лет в «Парусах» — это и вид на Петербург, и живая музыка, и торт с 40 свечами. Гости запомнят место, а именинник запомнит момент."
      },
      {
        "heading": "Стоимость и бронирование",
        "body": "Банкетное меню от 2 500 ₽/чел. Для 40–80 гостей — от 100 000 до 200 000 ₽ на еду. Алкоголь — отдельно. Бронируйте за 3–5 недель. +7 (812) 991-10-90.",
        "list": [
          "Банкетное меню от 2 500 ₽/чел",
          "Бронируйте за 3–5 недель",
          "Ведущий — через партнёров",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей 40 лет", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "yubiley-50-let-restoran-spb",
    "title": "Юбилей 50 лет в Петербурге: золотая дата — золотое место",
    "metaTitle": "Юбилей 50 лет в Петербурге — ресторан | Паруса на крыше",
    "metaDescription": "Юбилей 50 лет в Санкт-Петербурге: банкет с видом, живая музыка. Банкетное меню от 2500 ₽/чел. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "юбилей 50 лет ресторан петербург, пятидесятилетие банкет спб, золотой юбилей",
    "date": "2026-06-20",
    "category": "День рождения в Петербурге",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Полвека — это событие, которое заслуживает особого места. Не просто ресторан, а место с историей, репутацией и видом, от которого перехватывает дыхание.",
    "sections": [
      {
        "heading": "50 лет: масштаб юбилея",
        "body": "На пятидесятилетии обычно собираются 40–100 человек: семья, друзья нескольких поколений, коллеги. Это самый разнородный состав гостей среди всех юбилеев. Место должно понравиться всем. «Паруса на крыше» именно таковы: панорамный вид нравится всем без исключения, авторская кухня достаточно разнообразна, сервис уважительный ко всем.",
        "list": [
          "До 100+ гостей разных поколений",
          "Вид нравится всем — вне зависимости от возраста",
          "Кухня разнообразная — для всех вкусов",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Программа юбилея 50 лет",
        "body": "Классика: встреча с шампанским — торжественный ужин — поздравления — вынос торта — вечеринка. Дополнительно: слайд-шоу «50 лет в 50 фотографиях», видеопоздравления от тех, кто не приехал, концертный номер (романсы, джаз), конкурс для гостей. В «Парусах» всё это реализуемо при подготовке.",
        "highlight": "Торт на 50 лет в «Парусах» — это не просто торт. Это момент: зал темнеет, появляются свечи, звучит живая музыка. Это то, что снимают на видео и хранят годами."
      },
      {
        "heading": "Организация и бронирование",
        "body": "Бронируйте за 5–7 недель. Это крупный юбилей, который нужно планировать заблаговременно. Банкетное меню от 2 500 ₽/чел. Программа вечера — согласовывается с менеджером. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 5–7 недель",
          "Программа вечера — согласовать заранее",
          "Банкетное меню от 2 500 ₽/чел",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей 50 лет", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "yubiley-60-let-gde-otmetit-spb",
    "title": "Юбилей 60 лет в Петербурге: место, которое уважают",
    "metaTitle": "Юбилей 60 лет в Петербурге | Паруса на крыше",
    "metaDescription": "Где отметить юбилей 60 лет в Санкт-Петербурге: ресторан с достоинством и видом. Банкетное меню, живая музыка. Скидка 20% именинникам.",
    "keywords": "юбилей 60 лет ресторан петербург, шестидесятилетие банкет спб, где отметить 60 лет",
    "date": "2026-06-20",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "60 лет — это место с достоинством. Не молодёжный формат, не пышная помпезность — а тёплый, достойный вечер с людьми, которые важны.",
    "sections": [
      {
        "heading": "Чего ожидают гости на юбилее 60 лет",
        "body": "На шестидесятилетии важно: хорошая кухня, комфортные условия, живая музыка (не громкая), уважительный сервис. Гости этого поколения знают разницу между хорошим и средним. Они оценят: правильную температуру блюд, внимательного официанта, спокойную атмосферу. «Паруса» всё это дают.",
        "list": [
          "Уважительный персональный сервис",
          "Комфортная акустика — не громко",
          "Качественная классическая кухня",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Программа юбилея",
        "body": "Для 60-летия хороша следующая программа: торжественный ужин с несколькими переменами, поздравления от каждого стола, слайд-шоу, вынос торта с поздравительной песней. Живая музыка — джаз или романсы — создаёт правильную атмосферу. В «Парусах» можно заказать конкретный стиль музыки.",
        "highlight": "«Паруса на крыше» работают с 2009 года. 17 лет юбилеев — это экспертиза, которую чувствуют гости. Команда знает, как провести такой вечер."
      },
      {
        "heading": "Детали бронирования",
        "body": "Бронируйте за 4–6 недель. Для 30–60 гостей — отдельный зал. Банкетное меню от 2 500 ₽/чел. Программа — согласовывается при бронировании. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 4–6 недель",
          "Зал на 30–60 гостей",
          "Банкетное меню от 2 500 ₽/чел",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей 60 лет", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "yubiley-mamy-gde-otmetit-spb",
    "title": "Юбилей мамы в Петербурге: как устроить праздник, о котором она мечтала",
    "metaTitle": "Юбилей мамы в Петербурге — ресторан | Паруса на крыше",
    "metaDescription": "Как организовать юбилей мамы в Санкт-Петербурге: красивый ресторан, вид на город, торт с поздравлением. Скидка 20% именинникам.",
    "keywords": "юбилей мамы петербург ресторан, день рождения мамы спб, праздник для мамы",
    "date": "2026-06-20",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Мама заслуживает лучшего. Когда вы выбираете для неё место — это ваше высказывание о том, как вы её цените. Выбирайте место, которое говорит само за себя.",
    "sections": [
      {
        "heading": "Как выбрать место для мамы",
        "body": "Мамы разные — и им нравятся разные места. Но есть общее: красиво, вкусно, внимательный сервис. «Паруса на крыше» попадают во все три категории. Панорамный вид на Петербург нравится всем без исключения. Авторская кухня угодит большинству вкусов. Сервис — уважительный и внимательный, что особенно важно для старшего поколения.",
        "list": [
          "Красиво: вид на Петербург с 6-го этажа",
          "Вкусно: авторская кухня",
          "Внимательно: персональный сервис",
          "Скидка 20% маме-именинницы"
        ]
      },
      {
        "heading": "Детали, которые трогают",
        "body": "Для мамы важны маленькие детали: её любимые цветы на столе, торт с поздравлением, песня или романс в нужный момент. В «Парусах» можно заранее согласовать все эти нюансы. Скажите, что это мамин юбилей, и команда постарается сделать вечер особенным. Именно за такое внимание нас и ценят.",
        "highlight": "Когда мама видит стол с цветами, слышит поздравление и узнаёт в торте свою любимую клубнику — это тот момент, ради которого всё организовывается."
      },
      {
        "heading": "Как организовать",
        "body": "Позвоните за 1–3 недели: +7 (812) 991-10-90. Расскажите о маме: сколько лет, сколько гостей, что важно для неё. Менеджер предложит вариант. Скидка 20% маме-именинницы.",
        "list": [
          "Расскажите о маме при бронировании",
          "Цветы принести самостоятельно или заказать",
          "Скидка 20% маме-именинницы",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей для мамы", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "semeynyy-prazdnik-restoran-spb",
    "title": "Семейный праздник в ресторане Петербурга: все вместе",
    "metaTitle": "Семейный праздник в ресторане Петербурга | Паруса на крыше",
    "metaDescription": "Семейный день рождения в Санкт-Петербурге: ресторан для всей семьи с детьми и взрослыми. Комфортные залы, вкусная кухня. Скидка 20% именинникам.",
    "keywords": "семейный праздник ресторан петербург, день рождения для семьи спб, ресторан для семьи",
    "date": "2026-06-20",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Семейный праздник — это когда за столом есть место всем: бабушке и внукам, маленьким детям и взрослым. Найти ресторан, который устроит всех — задача непростая. Разбираем, как это сделать в Петербурге.",
    "sections": [
      {
        "heading": "Что нужно для семейного праздника",
        "body": "Для семейного праздника важно: разнообразное меню (чтобы нашли что-то все — и дети, и бабушки), достаточно места (чтобы никто не стеснялся), хороший сервис (внимательный ко всем возрастам), доступность (лифт для пожилых, место для колясок). В «Парусах» всё это учтено: Olympic Plaza имеет хорошую доступность, меню разнообразное, персонал обучен работать с семьями.",
        "list": [
          "Разнообразное меню для всех",
          "Доступность: лифт в Olympic Plaza",
          "Место для всех возрастов",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Дети на семейном празднике",
        "body": "Если на семейном юбилее будут дети — обсудите это при бронировании. В «Парусах» детское меню доступно. Можно попросить место, удобное для детских стульчиков. Ранний ужин (18:00–20:00) — лучше для семей с маленькими детьми. Важно: скажите о детях заранее, чтобы персонал был готов.",
        "highlight": "Семейный праздник в «Парусах» — это когда дедушка смотрит в окно на Петербург и говорит: «вот это место». Именно такой эффект нам нравится создавать."
      },
      {
        "heading": "Организация и бронирование",
        "body": "Для семейного праздника на 15–30 человек — за 1–2 недели. Для 30–80 — за 3–4 недели. Скажите количество детей при бронировании. +7 (812) 991-10-90.",
        "list": [
          "15–30 гостей: бронируйте за 1–2 недели",
          "30–80 гостей: за 3–4 недели",
          "Скажите о детях при бронировании",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать семейный праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-vsya-semya-restoran-peterburg",
    "title": "День рождения, где вся семья вместе: как выбрать ресторан",
    "metaTitle": "День рождения для всей семьи в Петербурге | Паруса на крыше",
    "metaDescription": "Ресторан для дня рождения с детьми и пожилыми в Санкт-Петербурге. Комфортно для всех. Скидка 20% именинникам. Банкетное меню.",
    "keywords": "день рождения вся семья петербург, семья разные возрасты ресторан спб, праздник для всех",
    "date": "2026-06-21",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Когда за столом есть и бабушка, и двухлетний внук — это семья. Ресторан должен быть достаточно хорошим, чтобы бабушка оценила, и достаточно гибким, чтобы с ребёнком не было проблем.",
    "sections": [
      {
        "heading": "Критерии выбора для смешанной семьи",
        "body": "Пять критериев: доступность (лифт, нет ступенек перед входом), детское меню, разнообразная кухня для разных вкусов, уровень шума (не слишком громко для пожилых), хороший сервис для всех. «Паруса на крыше» проходят по всем пяти. Olympic Plaza — торговый комплекс с хорошей инфраструктурой.",
        "list": [
          "Лифт и доступность: Olympic Plaza",
          "Детское меню: доступно",
          "Кухня: разнообразная",
          "Уровень шума: умеренный"
        ]
      },
      {
        "heading": "Рассадка для смешанной компании",
        "body": "Для смешанной семьи хорошо работает несколько столов или большой стол-«подкова». Детей удобнее посадить ближе к краю, чтобы можно было выйти без суеты. Пожилых — в более тихой части зала. При бронировании скажите об этих предпочтениях — персонал постарается помочь.",
        "highlight": "Смешанная семья за одним столом в «Парусах» — это тот момент, когда разница поколений стирается. Панорамный вид работает на всех одинаково."
      },
      {
        "heading": "Как организовать",
        "body": "Позвоните за 1–2 недели: +7 (812) 991-10-90. Расскажите о составе гостей: сколько детей, есть ли пожилые, нужен ли детский стульчик. Скидка 20% именинникам. Десерт в подарок.",
        "list": [
          "За 1–2 недели для 10–20 гостей",
          "Расскажите о детях и пожилых",
          "Детский стульчик — по запросу",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать семейный стол", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "detskiy-den-rozhdeniya-restoran-spb-gde",
    "title": "Детский день рождения в ресторане Петербурга: что нужно знать",
    "metaTitle": "Детский день рождения в ресторане СПб | Паруса на крыше",
    "metaDescription": "Как организовать детский день рождения в ресторане Санкт-Петербурга. Детское меню, торт, праздничная атмосфера. Скидка 20% именинникам.",
    "keywords": "детский день рождения ресторан спб, день рождения ребёнка петербург, праздник ребёнку ресторан",
    "date": "2026-06-21",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Детский день рождения в ресторане — это не только торт и конкурсы. Это первый опыт «настоящего ресторана» для ребёнка. Выбирайте место, где ему будет хорошо и родители не будут нервничать.",
    "sections": [
      {
        "heading": "Что важно для детского праздника в ресторане",
        "body": "Детский день рождения в ресторане требует: детского меню (понятная еда, без экзотики), хорошего сервиса для детей (быстрая подача, терпение), достаточно места для подвижности, торта с любимым персонажем или дизайном. В «Парусах» детское меню есть, персонал привык к детям. Вид с 6-го этажа даже детям нравится — некоторые впервые видят Петербург сверху.",
        "list": [
          "Детское меню: доступно",
          "Персонал: привык к детям",
          "Вид сверху — для детей тоже впечатление",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Возраст имеет значение",
        "body": "Для малышей до 5 лет: важна скорость подачи (они не ждут), тихая обстановка (не пугает), мягкий декор. Для 6–10 лет: торт с любимым персонажем, небольшие сюрпризы, может быть аниматор. Для 10–14 лет: более взрослый формат, возможно с музыкой. В «Парусах» адаптируемся под возраст — скажите при бронировании.",
        "highlight": "Детский день рождения в ресторане — это инвестиция в первые воспоминания. Когда ребёнок через 20 лет вспомнит свой 7-й день рождения — пусть это будет вид на Петербург."
      },
      {
        "heading": "Организация",
        "body": "Для детского праздника: небольшая компания (10–20 гостей), ранний вечер (17:00–19:00 лучше). Торт под заказ с любимым персонажем. Бронируйте за 1–2 недели. +7 (812) 991-10-90.",
        "list": [
          "10–20 гостей — оптимально",
          "Ранний вечер: 17:00–19:00",
          "Торт с персонажем под заказ",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать детский праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-rebenka-2-7-let-spb",
    "title": "День рождения ребёнка 2–7 лет в Петербурге: ресторан для малышей",
    "metaTitle": "День рождения ребёнка 2–7 лет в Петербурге | Паруса",
    "metaDescription": "День рождения малыша 2–7 лет в ресторане Санкт-Петербурга. Детское меню, торт, аниматор. Скидка 20% именинникам.",
    "keywords": "день рождения ребёнка 2 года 3 4 5 6 7 лет ресторан спб, малыш день рождения петербург",
    "date": "2026-06-21",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Праздник для малыша 2–7 лет — задача для родителей, а не для ребёнка. Им важно: чтобы было вкусно, безопасно и чтобы торт с любимым персонажем принесли в нужный момент. Остальное — взрослые придумают.",
    "sections": [
      {
        "heading": "Особенности праздника для малышей",
        "body": "Дети до 7 лет не любят ждать. Еда должна приходить быстро. Порции должны быть маленькими. Никакой экзотики. Понятный «куриный суп» и «макароны с сыром» — лучше, чем авторские блюда. В «Парусах» это понимают: простое детское меню доступно. Скажите при бронировании возраст детей — адаптируем.",
        "list": [
          "Быстрая подача — дети не ждут",
          "Простое детское меню",
          "Безопасная обстановка",
          "Торт с персонажем под заказ"
        ]
      },
      {
        "heading": "Что добавить для праздника малыша",
        "body": "Аниматор на 1–2 часа — если нужна программа. Воздушные шарики от вас (принесите с собой). Фотограф — чтобы родители не пропустили момент. Торт с любимым героем (Пеппа Свинка, Человек-паук — что угодно). В «Парусах» есть возможность привести своего аниматора — скажите при бронировании.",
        "highlight": "Для малыша главное — торт и мама рядом. Всё остальное — для папы и гостей. Выбирайте место, где родители могут расслабиться."
      },
      {
        "heading": "Практические детали",
        "body": "Ранний вечер: 17:00–19:00 или суббота–воскресенье в 13:00. Небольшая компания: 10–15 гостей с детьми. Детские стульчики — по запросу. Бронируйте за 1–2 недели. +7 (812) 991-10-90.",
        "list": [
          "17:00–19:00 или воскресенье 13:00",
          "10–15 гостей: оптимально",
          "Детские стульчики по запросу",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать для малыша", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "yubiley-roditeley-restoran-peterburg",
    "title": "Юбилей родителей в Петербурге: как устроить им незабываемый вечер",
    "metaTitle": "Юбилей родителей в Петербурге — ресторан | Паруса на крыше",
    "metaDescription": "Организация юбилея для родителей в Санкт-Петербурге. Красивый ресторан, комфортные условия, вкусная кухня. Скидка 20% именинникам.",
    "keywords": "юбилей родителей петербург, праздник для родителей ресторан спб, день рождения родителей",
    "date": "2026-06-21",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Устроить праздник для родителей — способ выразить то, о чём трудно говорить словами. Выбор места говорит: «я знаю, что ты заслуживаешь лучшего». «Паруса на крыше» — именно это.",
    "sections": [
      {
        "heading": "Что важно для родителей",
        "body": "Родители старшего поколения ценят: уважительный сервис, хорошую классическую кухню, комфортную обстановку (не слишком громко, не слишком тесно), красивое место. В «Парусах» это сочетание — стандарт. Вид на Петербург с 6-го этажа нравится всем возрастам. Панорама — это лучший декор без затрат.",
        "list": [
          "Уважительный сервис для старшего поколения",
          "Комфортная акустика",
          "Классическая кухня разнообразна",
          "Вид на Петербург — для всех"
        ]
      },
      {
        "heading": "Сценарий вечера для родителей",
        "body": "Лучший сценарий: вся семья за одним столом, несколько перемен блюд, поздравления детей, торт с именем и датой, живая музыка в нужный момент. Если есть возможность — сделайте слайд-шоу: «60 фотографий за 60 лет». Это трогает сильнее, чем любые слова. В «Парусах» можно использовать проектор.",
        "highlight": "Когда родители видят, что вы выбрали для них лучшее место — это важнее любого подарка. Это ваше высказывание о любви."
      },
      {
        "heading": "Как организовать",
        "body": "Позвоните за 2–3 недели: +7 (812) 991-10-90. Расскажите о родителях и их предпочтениях. Скидка 20% именинникам. Проектор под запрос.",
        "list": [
          "Бронируйте за 2–3 недели",
          "Расскажите о предпочтениях родителей",
          "Проектор для слайд-шоу — по запросу",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать для родителей", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-s-rodichelyami-restoran-spb",
    "title": "День рождения с родителями в ресторане Петербурга: всё под одной крышей",
    "metaTitle": "День рождения с родителями в ресторане СПб | Паруса",
    "metaDescription": "День рождения с родителями и своими друзьями в ресторане Петербурга. Как совместить разные поколения за одним столом. Скидка 20% именинникам.",
    "keywords": "день рождения с родителями ресторан спб, смешанная компания день рождения петербург",
    "date": "2026-06-21",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "День рождения, где есть и друзья, и родители — классический вызов. Как угодить всем? Разбираем стратегию в одном ресторане.",
    "sections": [
      {
        "heading": "Смешанная компания: как это работает",
        "body": "Друзья хотят веселья, родители — тишины и уважения. Ресторан, который даёт и то и другое — идеален. «Паруса» подходят: можно рассадить родителей в более тихой части зала, друзей — там, где живая музыка ближе. Все за одним событием, но в комфорте для каждого.",
        "list": [
          "Разная рассадка для разных поколений",
          "Единое событие — разный комфорт",
          "Скидка 20% именинникам",
          "Десерт в подарок"
        ]
      },
      {
        "heading": "Что помогает объединить всех",
        "body": "Вынос торта — тот момент, когда все собираются вместе. Общий тост от ведущего или самого именинника. Фото на фоне панорамы Петербурга — хороший финал вечера, который объединяет всех гостей. В «Парусах» вид с 6-го этажа — естественная точка сбора.",
        "highlight": "Вынос торта с живой музыкой объединяет любое сборное общество. Это работает на 100%."
      },
      {
        "heading": "Организация",
        "body": "Бронируйте за 1–2 недели для 15–30 гостей. Скажите о смешанной компании — поможем с рассадкой. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 1–2 недели",
          "Скажите о смешанной компании",
          "Поможем с рассадкой",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать смешанную компанию", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "yubiley-babushki-restoran-spb",
    "title": "Юбилей бабушки в Петербурге: как сделать ей самый тёплый вечер",
    "metaTitle": "Юбилей бабушки в Петербурге — ресторан | Паруса на крыше",
    "metaDescription": "Как организовать юбилей бабушки в Санкт-Петербурге. Ресторан с комфортом, вкусная кухня, семейная атмосфера. Скидка 20% именинницам.",
    "keywords": "юбилей бабушки ресторан петербург, день рождения бабушки спб, праздник бабушке",
    "date": "2026-06-21",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Бабушкин юбилей — самый тёплый из всех. Она смотрит на детей, внуков и правнуков — и это лучший подарок. Выберите место, которое создаёт правильную атмосферу для этого момента.",
    "sections": [
      {
        "heading": "Что важно для бабушкиного юбилея",
        "body": "Бабушке важно: видеть всю семью вместе, слышать поздравления, видеть торт со свечами, чтобы было вкусно и комфортно. В «Парусах» на это работает всё: уважительный персонал, разнообразная кухня, хорошее освещение (не слишком тёмное, как в модных ресторанах), комфортная температура в залах.",
        "list": [
          "Уважительный персонал",
          "Хорошее освещение — не ресторанный полумрак",
          "Комфортная температура",
          "Скидка 20% именинницам"
        ]
      },
      {
        "heading": "Атмосфера семейного тепла",
        "body": "Когда бабушка видит, что ради неё собрались все — это главное. Место должно не мешать этому, а помогать. «Паруса» создают нейтральный, достойный фон, который не конкурирует с семейным теплом. Вид на Петербург — добавляет торжественности.",
        "highlight": "Бабушкин юбилей — это не про ресторан. Это про то, что вся семья вместе. Место просто помогает этому быть."
      },
      {
        "heading": "Организация",
        "body": "Для бабушкиного юбилея: 15–40 гостей, ранний вечер (17:00), удобная рассадка, торт с числом лет. Бронируйте за 2–3 недели. +7 (812) 991-10-90.",
        "list": [
          "17:00 — ранний вечер для пожилых",
          "Удобная рассадка — просите менеджера",
          "Торт с числом лет",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать для бабушки", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-podrostka-restoran-spb",
    "title": "День рождения подростка в ресторане Петербурга: как угодить",
    "metaTitle": "День рождения подростка в ресторане СПб | Паруса на крыше",
    "metaDescription": "День рождения подростка (12–17 лет) в ресторане Санкт-Петербурга. Атмосфера, меню, живая музыка. Скидка 20% именинникам.",
    "keywords": "день рождения подростка ресторан спб, праздник тинейджера петербург, день рождения 12 15 лет",
    "date": "2026-06-21",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Подростки — самая требовательная аудитория. «Это скучно» можно услышать о любом месте. Но панорамный вид на ночной Петербург с 6-го этажа и живая музыка — это другое. Это работает даже на самых сложных критиков.",
    "sections": [
      {
        "heading": "Что цепляет подростков",
        "body": "Подросткам важна: атмосфера (не «как у родителей»), красивые фото для соцсетей, музыка, ощущение «взрослости». «Паруса на крыше» дают это всё. Вид с 6-го этажа — это идеальный фон для Instagram. Живая музыка — это не детская вечеринка. Авторская кухня — это «по-взрослому».",
        "list": [
          "Вид с 6-го этажа — лучший фон для фото",
          "Живая музыка — не детский праздник",
          "Взрослая атмосфера для первого раза",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Формат для подростков",
        "body": "Для подростков 12–15 лет: небольшая компания (6–12 человек), ужин с родителями или без. Для 16–17 лет: уже практически взрослый формат, можно игристое без алкоголя, ужин как у взрослых. Скажите возраст при бронировании — персонал подберёт правильный тон общения.",
        "highlight": "День рождения подростка в «Парусах» — это первый «настоящий» ужин в ресторане. Это запоминается на всю жизнь."
      },
      {
        "heading": "Организация",
        "body": "Для подростка: 8–15 гостей, стол у окна с видом. Торт с любимой тематикой. Бронируйте за 3–5 дней. +7 (812) 991-10-90.",
        "list": [
          "8–15 гостей",
          "Стол у окна — обязательно",
          "Торт с тематикой подростка",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать для подростка", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-studenta-restoran-spb",
    "title": "День рождения студента в Петербурге: атмосферно и не дорого",
    "metaTitle": "День рождения студента в ресторане СПб | Паруса на крыше",
    "metaDescription": "Где отметить день рождения студента в Санкт-Петербурге: ресторан с видом и бизнес-ланчем от 590 ₽. Скидка 20% именинникам.",
    "keywords": "день рождения студента ресторан спб, недорогой праздник петербург, бюджетный день рождения спб",
    "date": "2026-06-21",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Студенческий день рождения — это вызов: хочется красиво, но бюджет ограничен. «Паруса на крыше» решают эту задачу: вид на Петербург не требует переплаты, а бизнес-ланч от 590 ₽ — это «красиво» в самом буквальном смысле.",
    "sections": [
      {
        "heading": "Как отметить красиво с ограниченным бюджетом",
        "body": "Бизнес-ланч в «Парусах» — от 590 ₽ в будние дни с 12:00 до 16:00. Для студенческого дня рождения в обед — отличный вариант: полноценный обед с видом на Петербург, не уступающий вечернему ужину по атмосфере. Живой музыки нет (только вечером), но вид есть. Средний чек вечером: ~1 300 ₽/чел.",
        "list": [
          "Бизнес-ланч от 590 ₽ в будни",
          "Обед с видом — не хуже вечернего",
          "Скидка 20% именинникам",
          "Стол у окна — по запросу"
        ]
      },
      {
        "heading": "Студенческая компания: форматы",
        "body": "10–15 студентов, один большой стол у окна, каждый заказывает сам (à la carte). Это гибко и по бюджету. Можно добавить бутылку вина на стол или выбрать по бокалу — как решит компания. Торт принесите с собой или закажите у нас под заказ.",
        "highlight": "Вид на Петербург с 6-го этажа — это не «дорого». Это «умно». Ты выбираешь место, которое впечатляет, но не разоряет."
      },
      {
        "heading": "Детали",
        "body": "Для студенческого дня рождения: бронируйте за 2–3 дня. Попросите стол у окна. Скажите о дне рождения. Скидка 20% именинникам — на личный счёт. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 2–3 дня",
          "Скидка 20% именинникам",
          "Бизнес-ланч в будни от 590 ₽",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать студенческий праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "yubiley-dedushki-gde-otmetit-peterburg",
    "title": "Юбилей дедушки в Петербурге: достойное место для мудрого человека",
    "metaTitle": "Юбилей дедушки в Петербурге — ресторан | Паруса на крыше",
    "metaDescription": "Где отметить юбилей дедушки в Санкт-Петербурге. Достойный ресторан с видом и хорошей кухней. Скидка 20% именинникам.",
    "keywords": "юбилей дедушки ресторан петербург, день рождения дедушки спб, праздник для дедушки",
    "date": "2026-06-22",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Дедушкин юбилей — это особое событие. Он заслуживает места, которое соответствует его достоинству. Выбор ресторана — это ваш способ показать это.",
    "sections": [
      {
        "heading": "Что важно для дедушки",
        "body": "Дедушки ценят: хорошую классическую кухню, правильное мясо или рыбу, хорошую водку или вино, комфортные условия и собственных детей и внуков рядом. «Паруса» дают хорошую кухню и правильную атмосферу. Вид на Петербург добавляет торжественности — он это оценит, даже если не скажет.",
        "list": [
          "Классическая кухня: хорошее мясо, рыба",
          "Правильный алкоголь: вино, водка",
          "Комфортные условия",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Тост за дедушку",
        "body": "Дедушкин юбилей — это когда каждый встаёт и говорит что-то важное. Ресторан должен создавать для этого условия: тихо между тостами, не суетно. В «Парусах» банкет в отдельном зале — это именно та среда.",
        "highlight": "Дедушкин юбилей — один из самых трогательных вечеров. Главное — собрать всех вместе. Место помогает этому быть красивым."
      },
      {
        "heading": "Организация",
        "body": "Для дедушкиного юбилея: 20–50 гостей, банкет в зале. Бронируйте за 3–4 недели. Банкетное меню от 2 500 ₽/чел. +7 (812) 991-10-90.",
        "list": [
          "20–50 гостей",
          "Бронируйте за 3–4 недели",
          "Банкетное меню от 2 500 ₽/чел",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать для дедушки", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "prazdnik-podrugam-kompaniya-spb",
    "title": "Праздник с подругами в Петербурге: девичник на день рождения",
    "metaTitle": "Праздник с подругами в Петербурге | Паруса на крыше",
    "metaDescription": "Девичник на день рождения в Санкт-Петербурге: ресторан с видом, игристое, живая музыка. Скидка 20% имениннице. Ул. Марата 5.",
    "keywords": "праздник с подругами петербург, девичник день рождения спб, девичья компания ресторан",
    "date": "2026-06-22",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "Девичник на день рождения — формат, который редко разочаровывает. Правильная компания, красивое место, хорошее вино и разговоры, которые нельзя вести при мужьях.",
    "sections": [
      {
        "heading": "Девичник в ресторане: как это устроить",
        "body": "Стол на 6–12 подруг у панорамных окон. Игристое на старт. Авторские блюда. Живая музыка — с четверга по воскресенье. Торт именинницы с поздравлением. Это всё, что нужно. «Паруса» дают именно этот набор — и вид на Петербург как бонус.",
        "list": [
          "Стол у окна на 6–12 подруг",
          "Игристое на старт",
          "Живая музыка чт–вс",
          "Скидка 20% имениннице"
        ]
      },
      {
        "heading": "Фото как часть вечера",
        "body": "Признаём честно: часть девичника — это фото. Вид на Петербург с 6-го этажа — это лучший фон в городе. Золотой час на закате летом — ещё лучше. Ваши фото с этого вечера запомнятся всем. Это часть удовольствия.",
        "highlight": "Девичник в «Парусах» — это когда в конце все говорят: «надо сюда вернуться». Мы к этому стремимся."
      },
      {
        "heading": "Детали",
        "body": "Девичник на 6–12 подруг: бронируйте за 3–5 дней. Стол у окна — по запросу. Скидка 20% имениннице. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 3–5 дней",
          "Стол у окна — по запросу",
          "Скидка 20% имениннице",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать девичник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "muzhskoy-den-rozhdeniya-formaty-spb",
    "title": "Форматы мужского дня рождения в Петербурге: от камерного до банкета",
    "metaTitle": "Форматы мужского дня рождения в Петербурге | Паруса на крыше",
    "metaDescription": "Форматы мужского дня рождения в Санкт-Петербурге: камерный ужин, вечеринка с друзьями, банкет. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "мужской день рождения форматы петербург, как отметить мужчине день рождения спб",
    "date": "2026-06-22",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Мужчины нечасто говорят, как хотят провести день рождения. Но если спросить — ответ обычно: «хорошо поесть, хорошо выпить, с правильными людьми». Разбираем, как это реализовать в Петербурге.",
    "sections": [
      {
        "heading": "Три формата мужского праздника",
        "body": "Камерный ужин с лучшими друзьями: 4–8 человек, стол у окна, хороший стейк, бутылка вина или виски. Просто и отлично. Вечеринка с компанией: 15–30 человек, небольшой зал, живая музыка, более свободный формат. Банкет-юбилей: 40–100 человек, отдельный зал, программа, ведущий. Все три работают в «Парусах».",
        "list": [
          "Камерный: 4–8 человек, стол у окна",
          "Вечеринка: 15–30 человек, зал",
          "Банкет: 40–100 человек, программа",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что подходит мужчинам",
        "body": "Мужчины как правило предпочитают меньше помпезности и больше качества. Правильное мясо важнее декора из шаров. Хорошее вино важнее праздничных стаканов. Вид на Петербург — естественная «атмосфера» без усилий. В «Парусах» это понимают: ресторан сделан для впечатления, а не для показухи.",
        "highlight": "Мужской праздник в «Парусах» — это когда место делает работу за тебя. Ты просто приходишь, и всё уже хорошо."
      },
      {
        "heading": "Бронирование",
        "body": "Выберите формат и позвоните: +7 (812) 991-10-90. Скажите количество гостей и дату. Менеджер предложит вариант. Скидка 20% именинникам.",
        "list": [
          "Выберите формат",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам",
          "Банкетное меню от 2 500 ₽/чел"
        ]
      }
    ],
    "cta": { "text": "Забронировать мужской праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "prazdnik-dlya-druga-restoran-peterburg",
    "title": "Праздник для друга в Петербурге: как организовать стильно",
    "metaTitle": "День рождения для друга в Петербурге | Паруса на крыше",
    "metaDescription": "Как организовать день рождения для друга в Санкт-Петербурге. Ресторан с видом, скидка 20% именинникам, живая музыка.",
    "keywords": "праздник для друга ресторан петербург, день рождения друга спб, где отвести друга день рождения",
    "date": "2026-06-22",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Организовать праздник для друга — значит показать, что цените. Выбор места говорит о многом. «Паруса на крыше» — то место, про которое потом говорят: «вот спасибо».",
    "sections": [
      {
        "heading": "Как удивить друга",
        "body": "Лучший подарок другу — неожиданное место. Не квартирная вечеринка, а ресторан с видом на Петербург с 6-го этажа. Живая музыка, авторская кухня, правильная атмосфера. Скажите менеджеру «сюрприз для друга» — помогут создать момент входа с эффектом.",
        "list": [
          "Неожиданное место — лучший подарок",
          "Скажите о сюрпризе при бронировании",
          "Скидка 20% имениннику-другу",
          "Десерт с поздравлением — в подарок"
        ]
      },
      {
        "heading": "Формат для друга",
        "body": "Небольшая компания друзей: 5–12 человек, стол у окна. Или сюрприз вдвоём: вы и он. Оба варианта работают. В «Парусах» есть и столы для двоих у окна, и большие столы для компании.",
        "highlight": "Сюрприз на день рождения друга в «Парусах» — это когда лифт открывается на 6-м этаже и он видит Петербург. После этого ничего объяснять не нужно."
      },
      {
        "heading": "Организация",
        "body": "Бронируйте за 2–4 дня. Скажите о дне рождения друга. Попросите стол у окна. Скидка 20% имениннику. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 2–4 дня",
          "Скажите о дне рождения",
          "Стол у окна",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать для друга", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "semeynyy-yubiley-restoran-spb",
    "title": "Семейный юбилей в Петербурге: как объединить всех за одним столом",
    "metaTitle": "Семейный юбилей в Петербурге — ресторан | Паруса на крыше",
    "metaDescription": "Семейный юбилей в Санкт-Петербурге: ресторан для всех поколений. Вместимость до 300 гостей. Банкетное меню от 2500 ₽/чел.",
    "keywords": "семейный юбилей ресторан петербург, юбилей для семьи спб, семейное торжество",
    "date": "2026-06-22",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Семейный юбилей — это когда за столом есть место всем: от малышей до прабабушки. Такое событие бывает раз в несколько лет. Место должно быть на высоте.",
    "sections": [
      {
        "heading": "Семейный юбилей: особенности",
        "body": "На семейном юбилее важно: все поколения за одним событием, хорошая кухня для всех вкусов, комфорт для пожилых, место для детей, атмосфера торжественности. «Паруса на крыше» справляются: вместимость до 300 гостей, несколько залов, лифт в Olympic Plaza, разнообразное меню.",
        "list": [
          "До 300 гостей всех возрастов",
          "Лифт и доступность",
          "Разнообразное меню",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Как организовать",
        "body": "Позвоните за 4–8 недель для большого семейного юбилея. Расскажите о составе гостей: сколько взрослых, детей, пожилых. Менеджер предложит зал и формат. Банкетное меню от 2 500 ₽/чел.",
        "highlight": "Семейный юбилей в «Парусах» — это когда через 20 лет все вспомнят «да, это было то самое место». Создаём такие воспоминания с 2009 года."
      },
      {
        "heading": "Бронирование",
        "body": "Бронируйте за 4–8 недель. Детально обсудите формат с менеджером. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 4–8 недель",
          "Детально обсудите с менеджером",
          "Банкетное меню от 2 500 ₽/чел",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Обсудить семейный юбилей", "href": "/banket" }
  }
];
